"use strict";

var _classCallCheck = require("/home/gitlab-runner/builds/o6jZzivs/0/root/rf-kiln/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/gitlab-runner/builds/o6jZzivs/0/root/rf-kiln/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Events = void 0;

var ClickEvent_1 = require("./ClickEvent");

var DivEvent_1 = require("./DivEvent");

var HoverEvent_1 = require("./HoverEvent");

var Events = /*#__PURE__*/function () {
  function Events() {
    _classCallCheck(this, Events);

    this.onClick = new ClickEvent_1.ClickEvent();
    this.onDiv = new DivEvent_1.DivEvent();
    this.onHover = new HoverEvent_1.HoverEvent();
    this.resize = true;
  }

  _createClass(Events, [{
    key: "onclick",
    get: function get() {
      return this.onClick;
    },
    set: function set(value) {
      this.onClick = value;
    }
  }, {
    key: "ondiv",
    get: function get() {
      return this.onDiv;
    },
    set: function set(value) {
      this.onDiv = value;
    }
  }, {
    key: "onhover",
    get: function get() {
      return this.onHover;
    },
    set: function set(value) {
      this.onHover = value;
    }
  }, {
    key: "load",
    value: function load(data) {
      var _a, _b, _c;

      if (data === undefined) {
        return;
      }

      this.onClick.load((_a = data.onClick) !== null && _a !== void 0 ? _a : data.onclick);
      var onDiv = (_b = data.onDiv) !== null && _b !== void 0 ? _b : data.ondiv;

      if (onDiv !== undefined) {
        if (onDiv instanceof Array) {
          this.onDiv = onDiv.map(function (div) {
            var tmp = new DivEvent_1.DivEvent();
            tmp.load(div);
            return tmp;
          });
        } else {
          this.onDiv = new DivEvent_1.DivEvent();
          this.onDiv.load(onDiv);
        }
      }

      this.onHover.load((_c = data.onHover) !== null && _c !== void 0 ? _c : data.onhover);

      if (data.resize !== undefined) {
        this.resize = data.resize;
      }
    }
  }]);

  return Events;
}();

exports.Events = Events;